var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M0 26.7h53.3V40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 13.3h53.3v13.4H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M0 0h53.3v13.3H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#c09300",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m26.7 20.2 4.6 4.2-.3-7.7c0-1.2-1.1-.9-1.8-.5q-1.2.7-2.5.2-1.5.5-2.5-.2c-.8-.4-1.8-.7-1.8.5l-.4 7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c09300",
    d: "m22.9 16.4-.3 7.5-.6.5.4-7.7zm.6.6-.2 6.2-.6.6.4-7.3zm.6.4-.2 5.3-.4.4.2-6zm.7.3-.3 4.5-.4.3.2-5zm.5 0-.1 3.7-.4.4.1-4zm5.1-1.3.4 7.5.5.5-.3-7.7zm-.6.6.3 6.2.5.6-.3-7.3zm-.6.4.2 5.3.5.4-.3-6zm-.6.3.2 4.5.4.3-.2-5zm-.6 0 .1 3.7.5.4-.2-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c09300",
    stroke: "#c09300",
    strokeWidth: 0.1,
    d: "m26.9 21 .6 3-.2.1-.2-.1-.4-2.6.2 2.6-.2.2-.2-.2.1-2.6-.4 2.6-.2.1-.2-.2.7-2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#c09300",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M25.2 19.7 24 24.2l1.7.3.8-3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c09300",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m24.8 21.3.2.3.8-.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c09300",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m25.4 20.3.2 1.7.5-.7m-.2.2.3 1m0-.3-.5.8m.2 1-.2-1m0 0-.2-.9-.4.6-.1-.6-.6.5.3 1 .4-.6.2.7zm-1.4 1.1.4-.5.2.8.3-.5.2.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#c09300",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m28.1 19.7 1.3 4.5-1.8.3-.7-3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c09300",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m28.5 21.3-.1.3-.9-.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c09300",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m28 20.3-.2 1.7-.6-.7m.3.2-.3 1m-.1-.3.5.8m-.1 1 .1-1m0 0 .2-.9.4.6.2-.6.5.5-.3 1-.3-.6-.3.7zm1.4 1.1-.4-.5-.2.8-.3-.5-.2.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#c09300",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2,
    d: "M26.7 26.3q2.1 0 3.3-.4.4 0 .3-.4l.4-.5-.5-.3q-.1-.5-.7-.3-1.2.3-2.8.3-1.8 0-2.8-.3-.6-.2-.7.3c-.3 0-.3.4-.6.3.3 0 0 .4.4.5q0 .3.3.4 1.3.3 3.4.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#c09300",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M24.9 24.2H26c.3 0 .4.5 0 .5h-1.3l-1.2-.3c-.4-.2-.1-.5 0-.4zm3.6 0h-1.3c-.2 0-.4.5 0 .5h1.3l1.2-.3q.4-.4 0-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#c09300",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M23.5 24q-.4 0-.3.6 0-.2.3-.3zm1.3 1 .2-.4-.1-.3a.2.2 0 0 0-.3.3zm1.5-.6q.4.1.2.6l-.3-.3zm3.5-.4q.5 0 .4.6l-.3-.3zm-1.3 1-.2-.4q0-.2.2-.3l.2.2zm-1.5-.6q-.4.1-.1.6l.2-.3zm-3.4-.3.4.1zm.6.2.3.1zm1.9.2h-.4zm-.6 0h-.4zm4.2-.4-.3.1zm-.5.2-.4.1zm-2 .2h.4zm.6 0h.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c09300",
    d: "M23.6 25v-.1m3.6.2h.1m0 .2v-.1h.1q0 .2 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c09300",
    d: "M23.9 24.7h-.3v.1h.2v.2h-.2l-.1.1v.2h.2l.2.1h.3l.2-.2V25h-.2v.3H24l-.1-.1V25l-.1.1v.1h-.1v-.5m.1.9q.2 0 0 0m1.5.1V25l.2.1v.2l-.1.1zm2-.7-.1.1v.3l-.1.2v.2h.5v-.4h-.1v.2h-.1zm0 .6h-.1m-2-.6H25v.7l-.1-.2q.2 0 0-.2l.1-.3-.2.1q-.1 0 0 .2 0 .2-.1 0h-.1v-.1h-.1v.2l-.2.1q0 .2.1 0h.6v.1l.2.1h.1v-.2l.1-.2V25m3.9-.3q-.2 0 0 .2l.2.1v.3h-.2l-.1.1-.2-.1h.2l-.1-.3q-.1 0 0 .2l-.1.1-.1.2-.1-.1h-.1l-.2.1v.1h.2v.2h-.1l.2-.1h.2q0-.2.2 0h.2v-.1h.3l.2-.2h.3v-.2H30v-.1l-.2-.3zm-.1.7h.1zm-1.4.5.1-.1v-.4l.1.1v.3zm-.5 0h.2zm-1.3-.6v.2l-.2-.2v.4h-.3l.1.1h.2l.1-.1h.5l.2.2.1-.2h.4v-.4h-.2l-.1.2v-.1zm.1.3h.4v.2-.1zm.8 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#c09300",
    strokeWidth: 0.1,
    d: "M26.7 21.8c2.1-1.7 2-4.1 2-4.1h-.2c-.5 0-1.6-.3-1.8-.6-.3.3-1.4.6-1.9.6h-.1s-.2 2.4 2 4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#c09300",
    strokeWidth: 0.1,
    d: "M28.5 17.9c-.5 0-1.4-.2-1.8-.6a4 4 0 0 1-1.8.6 5 5 0 0 0 1.8 3.7 5 5 0 0 0 1.8-3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c09300",
    d: "m26 17.7-1.1.2v.2a5 5 0 0 0 1 2.8zm1.3 0v3.2a5 5 0 0 0 1.2-2.8V18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#c09300",
    strokeWidth: 0.1,
    d: "M27.5 16.9v-.3c0 .2.5.2.5.2-.3-.1-.5-1-.5-1.7q0-1-.2-1.1-.3-.3-.9-.3v.1h-.8c-.1 0-.2.5 0 .4q.2-.1.5.2v1.2l-.8 1.2.7-.2-.1.3q.5-.1.5-.3l.3.3.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c09300",
    strokeWidth: 0.1,
    d: "M26.4 15.2s-.1 1-.4 1.4m.6-1.5s0 1.2-.2 1.5m.5-1.4v1.4m.2-1.4s0 1 .3 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c09300",
    d: "M26.1 14.6v-.2q-.3-.3-.6-.2l.3-.2q.1-.1.6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c09300",
    d: "M25.5 14v-.2h.9q.5 0 .9.2v.1h-.6v.1h-.2L26 14l-.4-.2z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEg);
export default __webpack_public_path__ + "static/media/eg.79d803f10ece8de9a65b8d5f7fdecb1c.svg";
export { ForwardRef as ReactComponent };